module.exports = __webpack_public_path__ + "img/IMG-20200823-WA0048.48b7cc48.jpg";